import { React, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Header from "./header";
import { Styles } from "./styles";
import MainDetails from "./main-details";
import Contacts from "./contacts";
import LogoSelect from "./logo-select";
import { Container, LinearProgress } from "@mui/material";
import {
  errorToaster,
  successToaster,
} from "../../../helper/toasterConfiguration";
import { api_Routes } from "../../../tools/api_Routes";
import { Helper } from "../../../tools/Helper";
import { useNavigate } from "react-router-dom";
import SliderSelect from "./slider-select";

const AddPanelForm = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [loader, setLoader] = useState(true);
  const [uploadOption, setUploadOption] = useState("logo");
  const [uploadSliderOption, setUploadSliderOption] = useState("uploadImages");

  const [selectedFont, setSelectedFont] = useState("Mockads");
  const [selectedColor, setSelectedColor] = useState("#EBF2FF");
  const [logoName, setLogoName] = useState("LOREM");
  const [fontSize, setFontSize] = useState(25);
  const [inputValue, setInputValue] = useState("");
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [countries, setCountries] = useState([]);
  const [formData, setFormData] = useState({
    smmpanel_name: "",
    smmpanel_loginuser: "",
    smmpanel_login_password: "",
    reading_type: "HTML",
    smmpanel_api_key: "",
    smmpanel_api_url: "",
    smmpanel_ticket_numper: "",
    smmpanel_date_of_ticket: "",
    smmpanel_url: "",
    description: "",
    smmpanel_email: "",
    smmpanel_instagram: "",
    smmpanel_skybe: "",
    smmpanel_telegram: "",
    smmpanel_fb: "",
    smmpanel_twitter: "",
    smmpanel_whatsapp: "",
    smmpanel_tel1: "",
    customLogo: "",
    logo: null,
    smmpanel_notice: "",
    url_service: "",
    trust: 0,
    country_id: "",
    paymentMethod: [],
  });

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleCoursesChange = (event, value) => {
    setFormData((prev) => ({
      ...prev,
      country_id: value ? value?.id : "",
    }));
  };

  const getCountries = async () => {
    const { response } = await Helper.Get({
      url: api_Routes.Countries.View,
      hasToken: true,
    });
    if (response) {
      setCountries(response);
    }
    setLoader(false);
  };

  useEffect(() => {
    getCountries();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const requiredFields = ["smmpanel_name", "smmpanel_url"];

    const updatedFormData = {
      ...formData,
    };

    const missingFields = requiredFields.filter(
      (field) => !updatedFormData[field]
    );

    // if (uploadOption === "logo") {
    //   if (!formData.logo) {
    //     missingFields.push("logo");
    //   }
    // } else if (uploadOption === "customLogo") {
    //   // Validate individual properties for custom logo
    //   if (!logoName || !selectedColor || !selectedFont || !fontSize) {
    //     missingFields.push(
    //         "customLogo properties (logoName, color, fontFamily, fontSize)"
    //     );
    //   }
    // }
    console.log(uploadSliderOption);
    if (uploadSliderOption === "enterUrls") {
      if (
        !updatedFormData.screenshot_urls ||
        updatedFormData.screenshot_urls.length === 0
      ) {
        updatedFormData.screenshot_urls =
          formData.smmpanel_url?.split(",").map((url) => url.trim()) || [];
      }
    } else if (uploadSliderOption === "uploadImages") {
      if (!updatedFormData.photos || updatedFormData.photos.length === 0) {
        updatedFormData.screenshot_urls =
          formData.smmpanel_url?.split(",").map((url) => url.trim()) || [];
      }
    }
    if (
      !updatedFormData.smmpanel_whatsapp &&
      !updatedFormData.smmpanel_telegram
    ) {
      missingFields.push("Telegram Or Whatsapp");
    }
    if (missingFields.length > 0) {
      errorToaster(
        `Please fill in all required fields: ${missingFields.join(", ")}`
      );
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    const form_data = new FormData();

    // Append form data based on the active upload option
    if (uploadOption === "logo" && formData.logo) {
      form_data.append("logo", formData.logo);
    } else if (uploadOption === "customLogo") {
      updatedFormData.customLogo = {
        fontSize: `${fontSize}px`,
        color: selectedColor,
        fontFamily: selectedFont,
        logoName: logoName,
      };
      Object.keys(updatedFormData.customLogo).forEach((key) => {
        form_data.append(`customLogo[${key}]`, updatedFormData.customLogo[key]);
      });
    }

    // Append other form data fields
    Object.keys(updatedFormData).forEach((key) => {
      const value = updatedFormData[key];
      if (value && key !== "logo" && key !== "customLogo") {
        if (key === "screenshot_urls") {
          // Append screenshot_urls as an array if it exists
          if (value.length > 0) {
            value.forEach((url, index) => {
              form_data.append(`screenshot_urls[${index}]`, url);
            });
          } else {
            form_data.append("screenshot_urls", ""); // Append empty string if array is empty
          }
        } else if (key === "photos" && uploadSliderOption === "uploadImages") {
          // Append photos as an array
          if (value.length > 0) {
            value.forEach((photo, index) => {
              form_data.append(`photos[${index}]`, photo);
            });
          }
        } else {
          console.log(key);
          form_data.append(key, value);
        }
      }
    });
    paymentMethod.forEach((method, index) => {
      form_data.append(`paymentMethod[${index}]`, method);
    });
    const result = await Helper.Post({
      url: api_Routes.Panels.Add,
      data: form_data,
      hasToken: true,
    });

    const { response, message } = result || {};

    if (response) {
      successToaster(message);
      navigate("/panels");
    }
    setIsLoading(false);
  };

  return (
    <Styles>
      <Container>
        <Header />
        {loader ? (
          <LinearProgress className="mt-3" />
        ) : (
          <form onSubmit={handleSubmit} className="main-container">
            <div className="data-container">
              <MainDetails
                handleChange={handleChange}
                formData={formData}
                countries={countries}
                handleCoursesChange={handleCoursesChange}
              />
              <Contacts
                handleChange={handleChange}
                paymentMethod={paymentMethod}
                setFormData={setFormData}
                setPaymentMethod={setPaymentMethod}
                inputValue={inputValue}
                setInputValue={setInputValue}
                formData={formData}
              />
            </div>
            <LogoSelect
              formData={formData}
              setFormData={setFormData}
              uploadOption={uploadOption}
              setUploadOption={setUploadOption}
              logoName={logoName}
              setLogoName={setLogoName}
              selectedFont={selectedFont}
              setSelectedFont={setSelectedFont}
              selectedColor={selectedColor}
              setSelectedColor={setSelectedColor}
              fontSize={fontSize}
              setFontSize={setFontSize}
            />
            <SliderSelect
              formData={formData}
              setFormData={setFormData}
              uploadOption={uploadSliderOption}
              setUploadOption={setUploadSliderOption}
            />
            <div className="submit-btn">
              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? (
                  <CircularProgress size={22} sx={{ color: "white" }} />
                ) : (
                  "Submit"
                )}
              </Button>
            </div>
          </form>
        )}
      </Container>
    </Styles>
  );
};

export default AddPanelForm;
